export default "__VITE_ASSET__BrqyL8JA__"